
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!outcomes.criterion";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'outcomes/-criterion';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<td class=\"rating\">\n  <div class=\"rating-wrap\">\n    <div class=\"show\" aria-expanded=\"true\">\n      <span class=\"points\">"
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points), options)))
    + "</span> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "points", "Points", options) : helperMissing.call(depth0, "t", "points", "Points", options)))
    + "\n      <a\n        href=\"#\"\n        class=\"edit_rating active\"\n        title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'description': ((depth0 && depth0.description)),
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "edit_criterion_rating_title", "Edit \"%{description}\" criterion rating", options) : helperMissing.call(depth0, "t", "edit_criterion_rating_title", "Edit \"%{description}\" criterion rating", options)))
    + "'\n        aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'description': ((depth0 && depth0.description)),
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "edit_criterion_rating_title", "Edit \"%{description}\" criterion rating", options) : helperMissing.call(depth0, "t", "edit_criterion_rating_title", "Edit \"%{description}\" criterion rating", options)))
    + "'\n        role=button\n        tabindex=0\n        aria-controls=\"edit_rating_";
  if (helper = helpers._index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0._index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-edit\"></i></a>\n    </div>\n    <div\n      class=\"edit\"\n      id=\"edit_rating_";
  if (helper = helpers._index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0._index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n      role=region\n      aria-expanded=\"false\"\n      tabindex=-1\n    >\n      <div class=\"row-fluid\" class=\"outcomes-edit-row\">\n        <div class=\"span7\">\n          <input type=\"text\" name=\"ratings[";
  if (helper = helpers._index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0._index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][description]\" class=\"outcome_rating_description\" value=\"";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "rating_description", "Criterion rating description", options) : helperMissing.call(depth0, "t", "rating_description", "Criterion rating description", options)))
    + "\">\n        </div>\n        <div class=\"span4 offset1\">\n          <input type=\"text\" name=\"ratings[";
  if (helper = helpers._index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0._index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "][points]\" style=\"width: 20px;\" class=\"outcome_rating_points\" value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points), options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "criterion_rating_points", "Criterion rating points", options) : helperMissing.call(depth0, "t", "criterion_rating_points", "Criterion rating points", options)))
    + "\"> <span class=\"outcomes-points-label\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "pts", "pts", options) : helperMissing.call(depth0, "t", "pts", "pts", options)))
    + "</span>\n        </div>\n      </div>\n\n      <div class=\"buttons row-fluid\">\n        <div class=\"span12\">\n          <div class=\"button-container\">\n            <button\n              class=\"btn btn-small delete_rating_link\"\n              type=\"button\"\n            >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "delete_criterion", "Delete", options) : helperMissing.call(depth0, "t", "delete_criterion", "Delete", options)))
    + "</button>\n            <button\n              class=\"btn btn-small btn-primary save_rating_link\"\n              aria-controls=\"edit_rating_";
  if (helper = helpers._index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0._index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n              type=\"button\"\n            >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.criterion")
  },data:data},helper ? helper.call(depth0, "close_rating", "Ok", options) : helperMissing.call(depth0, "t", "close_rating", "Ok", options)))
    + "</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</td>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('outcomes/criterion', templates['outcomes/-criterion']);
    ;
    ;
    export default templates[name];
  